import { EnemyAI, FightingTriggers, IdleBehaviours, FightingBehaviours, LeashTriggers, LeashingBehaviours, AttackTypes, DeadBehaviours, ShotLeadPrecision, EnemyType, EnemyTargetingStyles } from '../ai-types'

import { SpineDataName, EnemyBipedSkinType } from '../../../models-animations/shared/spine-config'
import { EnemyDefaults } from './enemy-defaults'
import { ColliderTraits, ColliderType } from '../../../collision/shared/colliders'
import { AnimationTrack } from '../../../models-animations/shared/animation-track'
import { ENEMY_NAMES } from './enemy-names'

const lanternPost: EnemyAI = {
	name: ENEMY_NAMES.LANTERN_POST,
	type: EnemyType.DESTRICTIBLE_PROP,
	appearance: {
		asset: SpineDataName.LANTERN_POST,
		skin: EnemyBipedSkinType.DEFAULT,
		color: [1, 0.75, 0.5],
		mixSettings: [
			{ from: AnimationTrack.IDLE, to: AnimationTrack.IDLE, duration: 0.0 },
			{ from: AnimationTrack.IDLE, to: AnimationTrack.DEATH, duration: 0.5333 },
		],
		spawnAnim: false,
		showHealthBarWhenFull: false,
	},
	general: {
		enemyLevel: 1,
		experienceWhenKilled: 1,
	},
	baseAttributes: {
		...EnemyDefaults.baseAttributes,
		colliders: [
			{
				type: ColliderType.Ellipse,
				rX: 60.95,
				rY: 50.70,
				position: [0, -30],
				traits: ColliderTraits.BlockMovementAndProjectileAndItem,
			},
		],
		maxHealth: 1,
		maxShields: 8,
		movementSpeed: 0,
		attackRate: 0,
		noFlip: true,
		colliderIsKinematic: true,

		lootDropProbability: 2,
		lootDropQuantity: 2,
	},
	soundEffects: {
		attack: 'Projectile_Blip',
		impact: 'SFX_Impact_Enemy_Rock',
	},
	states: {
		idling: {
			behaviour: IdleBehaviours.STATIONARY,
			targetingStyle: EnemyTargetingStyles.NEAREST,
			targetingCheckSeconds: 1,
			transitionToFighting: {
				trigger: FightingTriggers.AGGRESSIVE_PROXIMITY,
				radius: 1200,
			},
			aggroOnHit: true,
		},
		fighting: {
			behaviour: FightingBehaviours.CHASE_AND_ATTACK,
			targetingStyle: EnemyTargetingStyles.NEAREST,
			targetingCheckSeconds: 1,
			attackType: AttackTypes.NONE,
			engagementMaxDistance: 1200,
			engagementMinDistance: 0,
			movementMaxDistance: 1200,
			movementMinDistance: 0,
			attackOptions: [],
			shotLeadPrecision: ShotLeadPrecision.AVERAGE,
			visualAimLockSeconds: 0.5,
			transitionToLeashing: {
				trigger: LeashTriggers.NONE,
			},
		},
		leashing: {
			behaviour: LeashingBehaviours.MOVE,
			speedMultiplier: 4,
			decelerateMultiplier: 0,
		},
		fleeing: {},
		dead: {
			behaviour: DeadBehaviours.BE_A_CORPSE,
			corpseTimeoutInSeconds: 1,
			persistentCorpse: false,
		},
	},
}

export default lanternPost
